import { alertActions } from "./alert.actions";
import { campaignConstants,notiConstants } from "../_constants";
import { campaignService } from "../_services";
import { userActions } from "./user.actions";
import { notiActions } from "./notification.actions";
export const campaignActions = {
    getAll,
    dialogOpen,
    dialogClose,
    signUp,
    checkUpdate,
    update,
    setDevices
};
let flag=0
let interval =0
Array.prototype.diff = function(a) {
    return this.filter(function(i) {return a.indexOf(i) < 0;});
};
function getAll() {
    return dispatch => {
        dispatch(request());
        dispatch(alertActions.loading("Loading...."));
        dispatch(campaignActions.checkUpdate(1));
        campaignService.getAll().then(
            campaigns => {
                dispatch(success(campaigns));
                dispatch(alertActions.clear());
            },
            error => {
                dispatch(failure(error));
                dispatch(alertActions.error(error));
            }
        );
    };

    function request() {
        return { type: campaignConstants.GETALL_REQUEST };
    }

    function success(campaigns) {
        return { type: campaignConstants.GETALL_SUCCESS, campaigns };
    }

    function failure(error) {
        return { type: campaignConstants.GETALL_FAILURE, error };
    }
}

function dialogOpen(userId, campaign) {
    if (!campaign.driverSigned) {
        campaign.driverSigned = 0;
    }
    return dispatch => {
        dispatch({ type: campaignConstants.DIALOG_OPEN, userId, campaign });
    };
}
function dialogClose() {
    return dispatch => {
        dispatch({ type: campaignConstants.DIALOG_CLOSE });
    };
}

function signUp(driverId, campaignId, campaignName) {
    return dispatch => {
        campaignService.signUp(driverId, campaignId, campaignName).then(
            success => {
                dispatch(alertActions.success(success.message));
                dispatch(userActions.campaignSigned(campaignId));
            },
            error => {
                dispatch(alertActions.error(error));
            }
        );
    };
}
function checkUpdate(state){
    return dispatch => {
        if (flag === 0 && state === 1) {
            flag = 1
            interval = setInterval(function(){
                dispatch(campaignActions.update())
            },5000)
        }else if (flag ===1  && state === 0){
            flag =0
            clearInterval(interval)
        }
    }
}
function update() {
    return dispatch => {

        campaignService.updateCampaigns().then(
            data => {

                let campaigns = []
                for (var key in data.campaignGroups){
                    campaigns[key]=data.campaignGroups[key].campaigns
                }
                let user = JSON.parse(localStorage.getItem("user"));
                if (data.accountBalance !== user.balance){
                    user.balance = data.accountBalance;
                    localStorage.setItem("user", JSON.stringify(user));
                    dispatch(userActions.updateBalance(data.accountBalance));
                }
                data.notification={}
                
                if (!data.noti){
                    data.notification.noti=[]
                    data.notification.ids=[]
                    data.notification.newNoti=0
                }else {
                    data.notification.noti=data.noti
                    data.notification.ids=[]
                    data.noti.map(function(key){
                        data.notification.ids.push(key.id)
                    })
                    if(data.oldNoti){
                        let oldIds= data.oldNoti.split(',').map(Number);
                        data.notification.newNoti = data.notification.ids.diff(oldIds).length    
                    }else {
                        data.notification.newNoti=data.notification.ids.length
                    }
                    
                }
                
                dispatch(notiActions.updateNoti(data.notification));
                dispatch(success(campaigns));
            },
            error => {
                dispatch(alertActions.error(error));
            }
        );
    };
    function success(campaigns) {
        return { type: campaignConstants.UPDATE_SUCCESS, campaigns };
    }
}

function setDevices(devs,id){
    let data = {
        data : devs,
        id : id
    }
    return { type: campaignConstants.SETDEVS_SUCCESS, data };
}


// WEBPACK FOOTER //
// ./src/_actions/campaign.actions.js